const PENDING_LIVE_STATUSES = new Set(['PENDING', 'PENDING_LIVE_CONFIRM']);
const ACCEPTED_STATUSES = new Set(['ACCEPTED', 'CONFIRMED', 'PENDING_CANCEL_LOCK']);

const firstText = (...values) => values
  .map((value) => (value == null ? '' : String(value).trim()))
  .find(Boolean) || '';

const firstNumber = (...values) => {
  for (const value of values) {
    if (value === undefined || value === null || value === '') continue;
    const number = Number(value);
    if (Number.isFinite(number)) return number;
  }
  return null;
};

const secondsUntil = (value) => {
  if (!value) return 0;
  const time = new Date(value).getTime();
  if (!Number.isFinite(time)) return 0;
  return Math.max(0, Math.ceil((time - Date.now()) / 1000));
};

const unwrapPlacementPayload = (source = {}) => {
  if (source?.data && typeof source.status === 'boolean') return source.data;
  return source?.data?.data || source?.data || source || {};
};

export const normalizeSportsnewBetPlacementResponse = (source = {}) => {
  const payload = unwrapPlacementPayload(source);
  const bet = payload?.bet || {};
  const originalStatus = firstText(
    payload.original_status,
    payload.originalStatus,
    payload.status,
    bet.status,
  ).toUpperCase();
  const betId = firstText(
    payload.bet_id,
    payload.betId,
    payload.public_id,
    payload.publicId,
    bet.public_id,
    bet.publicId,
    bet.id,
  );
  const delayExpiresAt = firstText(
    payload.delay_expires_at,
    payload.delayExpiresAt,
    payload.confirmation_due_at,
    payload.confirmationDueAt,
    bet.confirmation_due_at,
    bet.confirmationDueAt,
  );
  const explicitDelaySeconds = firstNumber(
    payload.delay_seconds,
    payload.delaySeconds,
    bet.delay_seconds,
    bet.delaySeconds,
  );
  const delaySeconds = Math.max(
    0,
    Math.ceil(explicitDelaySeconds ?? secondsUntil(delayExpiresAt)),
  );
  const isPendingLive = PENDING_LIVE_STATUSES.has(originalStatus) && Boolean(betId);
  const historyRow = payload?.history_row
    && typeof payload.history_row === 'object'
    && !Array.isArray(payload.history_row)
    ? payload.history_row
    : null;

  return {
    raw: payload,
    bet,
    betId,
    status: isPendingLive ? 'PENDING' : (ACCEPTED_STATUSES.has(originalStatus) ? 'ACCEPTED' : originalStatus),
    originalStatus,
    delaySeconds,
    delayExpiresAt,
    isPendingLive,
    historyRow,
  };
};
